import { createContext } from 'react'

export type CollapsibleCardGroupContextValue = {
    openItemId: string | null
    setOpenItemId: (itemId: string | null) => void
    hasInteracted: boolean
    setHasInteracted: (hasInteracted: boolean) => void
}

export const CollapsibleCardGroupContext = createContext<CollapsibleCardGroupContextValue | null>(null)
